import VideoPlayer from '../tools/video-player'
import SiteStructure from '../tools/site-structure'
import OneClickCover from './OneClickCover'
import EventBus from './../../event-bus'

export default {
  props: ['index'],
  components: {
    OneClickCover
  },
  beforeCreate: function () {
    this._bodyName = null
    this.v = []
    this._data = {
      isSelected: false,
      bodyComponent: null
    }
  },
  mounted () {
    EventBus.$on(this.navEventID + '.CHANGE', this.onNavChange)
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    for (let i = 0; i < this.v.length; i++) {
      if (this.v[i]) this.v[i].destroy()
    }
    EventBus.$off(this.navEventID + '.CHANGE', this.onNavChange)
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    setupVideo (vimeo, iframe, ref) {
      if (!ref) ref = this.$refs.video_player
      this.v.push(VideoPlayer(ref, vimeo, iframe))
    },
    onNavChange (e) {
      let i
      if ((this.index > -e.index - e.range) && this.index < (-e.index + e.range)) {
        for (i = 0; i < this.v.length; i++) {
          if (this.v[i]) this.v[i].reload()
        }
      }
      // eslint-disable-next-line
      if (this.index == -e.index) {
        this._data.isSelected = true
      } else {
        this._data.isSelected = false
        for (i = 0; i < this.v.length; i++) {
          if (this.v[i]) this.v[i].pause()
        }
      }
      if ((this.index >= -e.index - 1) && this.index <= (-e.index + 1)) {
        this.loadBody()
      }
    },
    setBody (b) {
      this._bodyName = b
    },
    loadBody () {
      if (this._bodyName) {
        this._data.bodyComponent = this._bodyName
      }
    },
    onScroll (e) {
      for (let i = 0; i < this.v.length; i++) {
        if (this.v[i]) this.v[i].onScroll()
      }
    },
    a: SiteStructure.a,
    goto: SiteStructure.goto
  },
  data () {
    return this._data
  }
}
